export function themeEditorLinks(search = window.location.search) {
  const params = new URLSearchParams(search);
  const shop = window.shopify?.config?.shop || params.get('shop') || params.get('shop_domain') || '';
  const apiKey = document.querySelector('meta[name="shopify-api-key"]')?.content || '';
  const available = /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i.test(shop) && /^[a-f0-9]{32}$/i.test(apiKey);
  if (!available) return {available: false, editor: '', addUrl: '', activateUrl: ''};

  const editor = `https://${shop}/admin/themes/current/editor?template=product`;
  return {
    available: true,
    editor,
    addUrl: `${editor}&addAppBlockId=${encodeURIComponent(`${apiKey}/cod-form`)}&target=mainSection`,
    activateUrl: `${editor}&context=apps&activateAppId=${encodeURIComponent(`${apiKey}/checkout-app-core`)}`,
  };
}
